export function getFormatedTooltipCategoriesChart(categories = []) {
  if (!categories) return []
  return categories?.map(category => {
    if (typeof category === 'object') {
      return category?.date
    }
    return category
  })
}
